import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-[#434654] p-6 plex-regular"
}
const _hoisted_2 = { class: "container mx-auto w-full md:max-w-7xl lg:max-w-5xl bg-white bg-opacity-85 rounded-lg p-6" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_4 = { class: "w-full px-2" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap py-2 mt-3 w-full" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_9 = { class: "pi pi-arrow-circle-down mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700",
      onInvalidSubmit: _ctx.onInvalidSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-full text-center py-6" }, [
            _createElementVNode("h1", { class: "plex-semibold text-xl text-gray-800" }, "CREDENCIAL"),
            _createElementVNode("h1", { class: "plex-semibold text-gray-800" }, "Por favor complete el formulario para descargar su credencial")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "block mb-1" }, "Documento", -1)),
              _createVNode(_component_Field, {
                name: "documento",
                modelValue: _ctx.formData.documento,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.documento) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Documento",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_ErrorMessage, { name: "documento" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "submit",
              class: "mt-4 w-full md:w-auto px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _cache[2] || (_cache[2] = _createTextVNode("DESCARGAR ", -1))
            ], 8, _hoisted_7)
          ])
        ]),
        _createVNode(_component_BlockUI, {
          blocked: _ctx.isSubmitting,
          fullScreen: ""
        }, null, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
  ]))
}